module.exports = new __parcel__URL__("chevronDown.05bec7e0.svg").toString();